import { fetchApiGraphQL } from "@/utils/fetcher";
import { createEnrichmentIsland } from "@/utils/islands";
import { confirmPropertyInterestMutation, ConfirmPropertyInterestResult } from "./estate-property-interest.query";

function showState(root: Element, state: "confirmed" | "error") {
    root.querySelectorAll<HTMLElement>("[data-state]").forEach((elm) => {
        elm.hidden = elm.dataset.state !== state;
    });
}

async function confirm(root: Element, token: string) {
    try {
        const result = await fetchApiGraphQL<ConfirmPropertyInterestResult>(confirmPropertyInterestMutation, { token }, true);
        showState(root, result.data.confirmPropertyInterest ? "confirmed" : "error");
    } catch (err) {
        console.log("Error while confirming property interest", err);
        showState(root, "error");
    }
}

export function initInterestButton() {

    createEnrichmentIsland("[data-estate-property-interest-button]", (root) => {
        const params = new URLSearchParams(document.location.search);
        const token = params.get("token");
        if (params.get("action") !== "propertyInterestConfirmation" || !token) {
            return;
        }
        void confirm(root, token);
    });
}
